kavrayskiy7 = require('projections/kavrayskiy-7')

module.exports = (lat, lng) ->
  coords = { x: 0, y: 0 }
  coords = kavrayskiy7({ lon: lng, lat: lat }) if lat? && lng?

  {
    lng:  lng
    lat:  lat
    lngX: coords.x
    latY: coords.y
    hasKavrayskiy7: true
  }


// WEBPACK FOOTER //
// ./assets/js/frontend/components/countries_map/components/map/lat_lng.coffee